import { AxiosResponse } from "axios";
import { api } from "../api";
import { GameTagCategory, GameTagDefinition } from "./gameTags.types";

export const getGameTags = async (
  category?: GameTagCategory,
): Promise<GameTagDefinition[]> => {
  try {
    const url = category
      ? `/game-tags?category=${encodeURIComponent(category)}`
      : "/game-tags";
    const response: AxiosResponse<GameTagDefinition[]> = await api.get(url);
    return response.status === 200 ? response.data : [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
